var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('platform',[_c('template',{slot:"content"},[_c('div',{staticClass:"auth"},[_c('el-card',{attrs:{"shadow":"never"}},[_c(_vm.isView,{tag:"component"})],1),_vm._v(" "),_c('div',{staticClass:"center"},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.toggleView}},[_vm._v("\n            "+_vm._s(_vm.buttonInfo)+"\n          ")])],1)],1)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55d097c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Auth.vue
// module id = null
// module chunks = 